import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagBrl = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_148_7008)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0004 4.69609L21.9135 12.0004L12.0004 19.3048L2.0874 12.0004L12.0004 4.69609Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0001 16.1738C14.3052 16.1738 16.174 14.3051 16.174 11.9999C16.174 9.69476 14.3052 7.82605 12.0001 7.82605C9.69489 7.82605 7.82617 9.69476 7.82617 11.9999C7.82617 14.3051 9.69489 16.1738 12.0001 16.1738Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.91324 11.7395C9.18743 11.7395 8.48698 11.8499 7.82764 12.0548C7.85684 14.3348 9.71328 16.1743 12.0002 16.1743C13.4143 16.1743 14.6633 15.4704 15.4183 14.3946C14.1266 12.7775 12.139 11.7395 9.91324 11.7395Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.0966 12.7998C16.1469 12.5409 16.174 12.2737 16.174 12.0001C16.174 9.69491 14.3053 7.82624 12.0001 7.82624C10.2801 7.82624 8.80355 8.86691 8.16455 10.3528C8.72939 10.2357 9.31421 10.1741 9.91322 10.1741C12.3375 10.174 14.5305 11.1817 16.0966 12.7998Z",
				fill: "#0052B4"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_148_7008",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgFlagBrl;
